import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Footer() {
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/slymnozdmrc"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/suleyman-ozdemirci-219b0149/"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/slymnozdmrc"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <AiFillInstagram />
              </a>
            </li>
          </ul>
        </Col>
        <Col md="4" className="footer-body text-center">
          <div className="legal-links" style={{ marginBottom: "8px" }}>
            <Link
              to="/terms-of-service"
              style={{ color: "#ccc", textDecoration: "none" }}
            >
              Terms of Service
            </Link>
          </div>
          <div className="legal-links">
            <span style={{ color: "#aaa", fontSize: "12px" }}>Privacy: </span>
            <Link to="/privacy-policy/dotsplosion" style={{ color: "#ccc", textDecoration: "none", marginRight: "10px", fontSize: "12px" }}>
              Dotsplosion
            </Link>
            <Link to="/privacy-policy/hangmango" style={{ color: "#ccc", textDecoration: "none", marginRight: "10px", fontSize: "12px" }}>
              Hangman Go
            </Link>
            <Link to="/privacy-policy/wordpop" style={{ color: "#ccc", textDecoration: "none", marginRight: "10px", fontSize: "12px" }}>
              WordPop
            </Link>
            <Link to="/privacy-policy/1to50" style={{ color: "#ccc", textDecoration: "none", fontSize: "12px" }}>
              1to50
            </Link>
          </div>
        </Col>
        <Col md="4" className="footer-body text-center">
          <p style={{ color: "white", fontSize: "14px" }}>
            © 2024 Süleyman Özdemirci
          </p>
          <p style={{ color: "#ccc", fontSize: "12px" }}>
            sozdemircim@gmail.com
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
